import * as React from "react";

export const CheckBox = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clip-path="url(#clip0_1_2764)">
      <rect width="16" height="16" rx="4" fill="#333333" />
      <rect x="0.4" y="0.4" width="15.2" height="15.2" stroke="#333333" stroke-width="0.8" />
      <path
        d="M12.8985 3.34494C12.454 3.05628 11.8295 3.14549 11.5044 3.54035L6.45957 9.69L4.78045 7.79944C4.43828 7.41547 3.81109 7.35011 3.37947 7.65304C2.94653 7.95596 2.87367 8.51487 3.21454 8.89755L6.52295 12.625L13.1166 4.584C13.4418 4.18781 13.3443 3.6336 12.8985 3.34494Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_2764">
        <rect width="16" height="16" rx="4" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UnChecked = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21" fill="none">
    <g clip-path="url(#clip0_8004_12880)">
      <rect x="0.5" y="1" width="19" height="19" stroke="#bdbdbd" />
    </g>
    <defs>
      <clipPath id="clip0_8004_12880">
        <rect y="0.5" width="20" height="20" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
